import { render } from "./Demos.vue?vue&type=template&id=e0432c52"
import script from "./Demos.vue?vue&type=script&lang=js"
export * from "./Demos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__